import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import FinanceCardChart from "../finance/financeCardChart/financeCardChart";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const REGIME_KEYS = ["integral", "parcial", "otherKnown", "unknownRegime"];
const QUALIFICATION_KEYS = ["mastersOrDoctors", "otherQualification"];

const TeacherRegimeQualificationChart = ({ teacherRegimeQualification, code, onBarClick, selectedBar }) => {
  const rq = teacherRegimeQualification || {};
  const integralMd = Number(rq.integral?.mastersOrDoctors || 0);
  const integralOther = Number(rq.integral?.otherQualification || 0);
  const parcialMd = Number(rq.parcial?.mastersOrDoctors || 0);
  const parcialOther = Number(rq.parcial?.otherQualification || 0);
  const otherMd = Number(rq.otherKnown?.mastersOrDoctors || 0);
  const otherOther = Number(rq.otherKnown?.otherQualification || 0);
  const unkMd = Number(rq.unknownRegime?.mastersOrDoctors || 0);
  const unkOther = Number(rq.unknownRegime?.otherQualification || 0);

  const isSelected = (datasetIndex, index) => {
    if (!selectedBar) return false;
    return selectedBar.regime === REGIME_KEYS[index] && selectedBar.qualification === QUALIFICATION_KEYS[datasetIndex];
  };

  const buildBgColors = (datasetIndex, baseColor) =>
    [0, 1, 2, 3].map((idx) =>
      selectedBar && !isSelected(datasetIndex, idx) ? `${baseColor}66` : baseColor
    );

  const data = {
    labels: ["Integral", "Parcial", "Outro regime", "Sem regime informado"],
    datasets: [
      {
        label: "Mestre ou doutor",
        data: [integralMd, parcialMd, otherMd, unkMd],
        backgroundColor: buildBgColors(0, "#0962AD"),
        borderColor: buildBgColors(0, "#0962AD"),
        borderWidth: 0
      },
      {
        label: "Demais titulações",
        data: [integralOther, parcialOther, otherOther, unkOther],
        backgroundColor: buildBgColors(1, "#2BAD70"),
        borderColor: buildBgColors(1, "#2BAD70"),
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: onBarClick
      ? (event, elements) => {
          if (elements.length > 0) {
            const el = elements[0];
            onBarClick({
              regime: REGIME_KEYS[el.index],
              qualification: QUALIFICATION_KEYS[el.datasetIndex]
            });
          }
        }
      : undefined,
    onHover: onBarClick
      ? (event, elements) => {
          event.native.target.style.cursor = elements.length > 0 ? "pointer" : "default";
        }
      : undefined,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxHeight: 6,
          color: "#858585",
          font: { size: 14 },
          usePointStyle: true
        }
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const n = ctx.raw ?? 0;
            return `${ctx.dataset.label}: ${Number(n).toLocaleString("pt-BR")} docente(s)`;
          },
          afterLabel: onBarClick ? () => "Clique para ver os docentes" : undefined
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#858585", font: { size: 12 } }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#D2D5DA"
        },
        ticks: {
          color: "#858585",
          precision: 0,
          callback: (value) => value
        }
      }
    }
  };

  return (
    <FinanceCardChart
      code={code}
      title="Docentes por regime de trabalho e titulação"
    >
      <div style={{ width: "100%", height: "100%", minHeight: "260px" }}>
        <Bar data={data} options={options} />
      </div>
    </FinanceCardChart>
  );
};

export default TeacherRegimeQualificationChart;
